export const oidcSettings = {
  authority: 'https://login.wrike.com',
  metadata: {
    authorization_endpoint: 'https://login.wrike.com/oauth2/authorize/v4',
    code_challenge_methods_supported: ['S256'],
    grant_types_supported: ['authorization_code'],
    response_types_supported: ['code'],
    token_endpoint: 'https://login.wrike.com/oauth2/token',
    token_endpoint_auth_methods_supported: ['client_secret_post'],
  },
  client_id: window.AppConfig.OAUTH2_CLIENT_ID,
  client_secret: window.AppConfig.OAUTH2_CLIENT_SECRET,
  redirect_uri: window.AppConfig.OAUTH2_REDIRECT_URI_BASE + 'oauth-callback',
  response_type: 'code',
  scope: 'wsReadOnly, amReadOnlyUser',
  loadUserInfo: false,

  silentRedirectUri: window.AppConfig.OAUTH2_REDIRECT_URI_BASE + 'silent-renew-oidc.html',
  automaticSilentRenew: true,
  automaticSilentSignin: true,
}